/** @format */

import TreeTypeEven from './type-evens';
import { queryWithSys as getRoleTreeData, findAllSubSystemOne, findTreeData } from '@/api/position/index';
import { allNoticeAll, orgFindTreeDataByAll } from '@/api/position';

import { TreeUtils } from '@/utils/tree';
import { $utils } from '@/utils/publicUtils';
// import FormUtils from '@/business/platform/form/utils/formUtil'

export default {
	mixins: [TreeTypeEven],
	props: {
		hasSubset: {
			// 是否包含子集
			type: Boolean,
			default: false,
		},
		// 额外配置
		options: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		checkTreeId(treeData) {
			const arr = [];
			const filter = function (datas) {
				datas.find((item) => {
					if (item.children && item.children !== []) {
						item.children.forEach((i) => {
							arr.push(i.id);
						});
						filter(item.children);
					}
				});
				return arr;
			};
			filter(treeData);
			this.treeIds = arr;
			this.loadListData();
		},
		loadTreeData(init = false, resetParams = false) {
			if (!this.showTree) return;
			this.hiddenTree = false;
			this.loadingTree = true;
			this.partyId = '';
			this.treeData = [];
			// if (this.$utils.isNotEmpty(this.extraOptions.initLoad) && !this.extraOptions.initLoad) {
			//   this.extraOptions.initLoad = true
			// }
			if (this.partyType === 'org') {
				this.lazyTree = true;
				this.defaultExpandedKeys = ['0'];
				this.defaultExpandAll = false;
				this.loadOrgTreeData(init, resetParams);
			} else {
				this.lazyTree = false;
				this.defaultExpandedKeys = null;
				this.defaultExpandAll = true;
				if (this.partyType === 'role') {
					this.loadRoleTreeData();
				} else if (this.partyType === 'group') {
					this.loadGroupTreeData();
				} else if (this.partyType === 'position') {
					this.loadPositionTreeData();
				}
			}
			this.loadListData();
		},
		toTree(data) {
			return TreeUtils.transformToTreeFormat(data, {
				idKey: 'id',
				pIdKey: 'parentId',
				childrenKey: 'children',
			});
		},
		setTree(lazy, data) {
			const ref = this.$refs.elTree;
			if (!ref) return;
			ref.store.lazy = lazy;
			ref.store.defaultExpandAll = !lazy;
			ref.store.defaultExpandedKeys = lazy ? ['0'] : null;
			ref.store.setData(data);
			if (
				lazy &&
				!this.isUseScope &&
				(this.partyType !== 'org' || (this.partyType === 'org' && this.partyTypeId !== '3'))
			) {
				// 普通模式懒加载函数调用
				ref.store.load = this.loadOrgTreeNode;
			} else if (lazy && this.isUseScope) {
				if (this.partyType === 'org') {
					ref.store.load = this.partyTypeId === '3' ? this.loadOrgTreeNode3 : this.loadOrgTreeNode;
				}
			}
		},
		// getScriptData(scriptValue, once = false) {
		// 	// this.hiddenTree = false

		// 	if (this.scriptExecuteTime) return;
		// 	const dynamicValue = FormUtils.getCalDynamicValue(scriptValue, this.formData);
		// 	dynamicValue.then((response) => {
		// 		const data = this.$utils.isJSON(response) ? JSON.parse(response) : response;
		// 		this.treeData = TreeUtils.transformToTreeFormat(data);
		// 		this.setTree(this.partyType === 'org', this.treeData);
		// 		this.scriptExecuteTime = once;
		// 	});
		// },
		handleTreeAction(command, position) {
			if (position === 'toolbar' && command.key === 'refresh') {
				this.refresh = false;
				this.$nextTick(async () => {
					this.refresh = true;
					this.defaultExpandAll = false;
					this.$emit('selected', []);
				});
			}
			if (command.key === 'expand') {
				this.expandCompressTree(true);
			} else if (command.key === 'compress') {
				this.expandCompressTree(false);
			}
		},
		async expandNode(node) {
			if (!node.isLeaf && !node.expanded) {
				node.expand();
				await new Promise((resolve) => {
					const unwatch = watch(
						() => node.childNodes.length,
						(length) => {
							if (length > 0) {
								unwatch();
								resolve();
							}
						},
						{ immediate: true },
					);
				});
				for (const child of node.childNodes) {
					await this.expandNode(child);
				}
			}
		},
		async expandCompressTree(expanded) {
			if (expanded) {
				const res = await orgFindTreeDataByAll({
					parameters: [
						{
							code: 'orgId',
							value: null,
						},
					],
				});
				if (this.partyType === 'org') {
					const res1 = await allNoticeAll();
					this.treeData = [{ ...res[0], children: res1 }];
					this.defaultExpandAll = true;
				} else {
					this.lazyTree = false;
					this.defaultExpandedKeys = null;
					this.defaultExpandAll = true;
					if (this.partyType === 'role') {
						this.loadRoleTreeData();
					} else if (this.partyType === 'group') {
						this.loadGroupTreeData();
					} else if (this.partyType === 'position') {
						this.loadPositionTreeData();
					}
				}
			} else {
				for (let i = 0; i < this.$refs.elTree.store._getAllNodes().length; i++) {
					this.$refs.elTree.store._getAllNodes()[i].expanded = expanded;
				}
			}
		},
		// 点击节点
		handleNodeClick(data) {
			if (data.id === '0' && this.partyTypeIdValue === '2') return;
			const ids = [];
			this.getChildrenIds(data, ids);
			if ((this.partyTypeIdValue === '5' || this.partyTypeIdValue === '3') && data.id === '0') {
				this.partyId = this.partyTypeIdValue === '5' ? this.extraOptions.externalGrounpId : this.currentOrgIdValue;
			} else {
				this.partyId = data.id;
			}
			this.loadListData();
		},
		// 加载机构树
		loadOrgTreeData(init, resetParams = false) {
			const type = this.partyTypeIdValue !== '' ? this.partyTypeIdValue : '1';
			this.loadingTree = true;
			this.hiddenTree = true;
			if (type === 'script') {
				this.hiddenTree = false;
				this.getScriptData(this.scriptValue);
				this.loadingTree = false;
				return;
			}
			const params = {};
			if (resetParams && this.isUseScope) {
				params.partyId = this.currentOrgIdValue;
				params.includeSub = false;
			}
			if (type === '2' || type === '3') {
				// 是否包含子集
				params.includeSub = this.hasSubset;
				params.partyId = this.currentOrgIdValue;
			}
			const initTreeTypeMethods = TreeTypeEven.orgTypeEven.methods;
			const initTreeTypeEven = TreeTypeEven.orgTypeEven.methods.initTreeTypeEven;
			initTreeTypeEven(type, params, initTreeTypeMethods, 'init').then((res) => {
				this.loadingTree = false;
				this.hiddenTree = false;
				// 普通模式
				if (!this.isUseScope) {
					if (type !== '5') {
						this.treeDatas = TreeUtils.transformToTreeFormat(res);
						this.setTree(true, this.treeDatas);
					} else {
						this.treeData = TreeUtils.transformToTreeFormat(res);
					}
				} else {
					// 选择器范围模式
					if (resetParams) {
						this.treeData = TreeUtils.transformToTreeFormat(res);
						this.setTree(true, this.treeData);
					} else {
						if (!init) {
							this.treeData = TreeUtils.transformToTreeFormat(res);
							this.setTree(true, this.treeData);
						}
						this.treeDatas = res;
					}
				}
			});
		},
		// 机构数节点函数【懒加载】
		loadOrgTreeNode(node, resolve) {
			this.loadingTree = true;
			const type = this.partyTypeIdValue !== '' ? this.partyTypeIdValue : '1';
			if (type === 'script') {
				const nodeData = this.filterTreeChildren(this.treeData, 'node', node.data.id);
				this.loadingTree = false;
				resolve(this.toTree(nodeData));
				return;
			}

			const initTreeTypeMethods = TreeTypeEven.orgTypeEven.methods;
			const nodeTreeTypeEven = TreeTypeEven.orgTypeEven.methods.initTreeTypeEven;
			if (type === '2' || type === '3') {
				this.extraOptions.includeSub = this.hasSubset;
			}
			nodeTreeTypeEven(type, node, initTreeTypeMethods, 'node', this.extraOptions).then((data) => {
				this.loadingTree = false;
				const arr = JSON.parse(JSON.stringify(data));
				let treeData;
				switch (type) {
					case '1':
						if (this.isUseScope && ($utils.isEmpty(node.data) || node.data.id === '0')) {
							// 初始化和查询全部时得数据加载
							treeData = arr;
							resolve(this.toTree(treeData));
						} else if (this.isUseScope && $utils.isArray(node.data) && node.data[0].id === '0') {
							// 节点数据为数组时得初始化处理
							treeData = arr;
							resolve(this.toTree(treeData));
						} else if (this.isUseScope && type === '1' && node.data.id !== '0') {
							resolve(this.toTree(arr));
						}
						if (!this.isUseScope && $utils.isEmpty(this.isSuperInitTree)) {
							resolve(this.toTree(arr));
						}
						break;
					case '2':
						if (this.isUseScope && ($utils.isEmpty(node.data) || node.data.id === '0')) {
							// 初始化和查询全部时得数据加载
							if ($utils.isEmpty(node.data)) {
								treeData = arr;
								resolve(this.toTree(treeData));
							} else {
								// 类型2得初始化数据节点筛选
								treeData = this.filterTreeChildren(arr, 'root');
								resolve(this.toTree(treeData));
							}
						} else if (this.isUseScope && $utils.isArray(node.data) && node.data[0].id === '0') {
							// 节点数据为数组时得初始化处理
							treeData = arr;
							resolve(this.toTree(treeData));
						} else if (this.hasSubset && node.data.id !== '0') {
							// 根据是否包含子节点返回对应的数据
							treeData = this.filterTreeChildren(this.toTree(arr), 'node', node.data.id);
							resolve(this.toTree(treeData));
						}
						if (!this.isUseScope && $utils.isEmpty(this.isSuperInitTree)) {
							resolve(this.toTree(arr));
						}
						break;
					case '5':
						if ($utils.isEmpty(node.data) || node.data.id === '0') {
							resolve(this.toTree(arr));
						} else {
							const nodeData = this.filterTreeChildren(this.toTree(arr), 'node', node.data.id);
							resolve(this.toTree(nodeData));
						}
						break;
				}
			});
		},
		// 加载岗位树
		loadPositionTreeData() {
			if (this.isUseScope) {
				// 选择器范围模式参数
				const params = { parameters: [], requestPage: {}, sorts: [] };
				const type = this.partyTypeIdValue !== '' ? this.partyTypeIdValue : '1';
				const initTreeTypeMethods = TreeTypeEven.roleTypeEven.methods;
				const initTreeTypeEven = TreeTypeEven.roleTypeEven.methods.findTreeDataTypes;

				if (type === 'script') {
					this.hiddenTree = false;
					this.getScriptData(this.scriptValue);
					this.loadingTree = false;
					return;
				}
				if (this.isUseScope) {
					params.parameters.push({ key: 'includeSub', value: this.partyTypeIdValue === '1' });
					if (type === '3') {
						params.parameters.push({ key: 'partyId', value: this.currentOrgIdValue });
					}
				}

				initTreeTypeEven(type, params, initTreeTypeMethods, this.extraOptions)
					.then((res) => {
						this.loadingTree = false;
						this.treeData = TreeUtils.transformToTreeFormat(res);
						this.setTree(false, this.treeData);
						this.checkTreeId(this.treeData);
					})
					.catch(() => {
						this.loadingTree = false;
					});
			} else {
				findTreeData()
					.then((response) => {
						const data = response;
						data.unshift({
							id: 0,
							name: '岗位树',
							parentId: null,
						});
						this.treeData = TreeUtils.transformToTreeFormat(data);
						this.setTree(false, this.treeData);
						this.checkTreeId(this.treeData);
						this.loadingTree = false;
					})
					.catch(() => {
						this.loadingTree = false;
					});
			}
		},
		// 岗位树节点函数
		loadPosTreeNode(node, resolve) {
			const moreSearchParams = this.moreSearchParams;
			const type = this.partyTypeIdValue !== '' ? this.partyTypeIdValue : '1';
			const initTreeTypeMethods = TreeTypeEven.positionTypeEven.methods;
			const nodeTreeTypeEven = TreeTypeEven.positionTypeEven.methods.findTreeDataTypes;
			if (this.isUseScope) {
				if (type === 'script') {
					this.hiddenTree = false;
					this.getScriptData(this.scriptValue);
					this.loadingTree = false;
					return;
				}
				const partyId = this.currentOrgId;
				if (type === '2' || type === '3') {
					this.extraOptions.includeSub = this.hasSubset;
				}
				nodeTreeTypeEven(type, { node, partyId, moreSearchParams }, initTreeTypeMethods, 'node', this.extraOptions)
					.then((res) => {
						resolve(res);
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
						resolve([]);
					});
			} else {
				nodeTreeTypeEven(type, { node, moreSearchParams }, initTreeTypeMethods, 'node')
					.then((res) => {
						resolve(res);
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
						resolve([]);
					});
			}
		},
		// 加载角色树
		loadRoleTreeData() {
			if (this.isUseScope) {
				// 选择器范围模式参数
				const params = { parameters: [], requestPage: {}, sorts: [] };
				const type = this.partyTypeIdValue !== '' ? this.partyTypeIdValue : '1';
				const initTreeTypeMethods = TreeTypeEven.roleTypeEven.methods;
				const initTreeTypeEven = TreeTypeEven.roleTypeEven.methods.findTreeDataTypes;

				if (type === 'script') {
					this.hiddenTree = false;
					this.getScriptData(this.scriptValue);
					this.loadingTree = false;
					return;
				}
				if (this.isUseScope) {
					params.parameters.push({ key: 'includeSub', value: this.partyTypeIdValue === '1' });
					if (type === '3') {
						params.parameters.push({ key: 'partyId', value: this.currentOrgIdValue });
					}
				}

				initTreeTypeEven(type, params, initTreeTypeMethods, this.extraOptions)
					.then((res) => {
						this.loadingTree = false;
						this.treeData = TreeUtils.transformToTreeFormat(res);
						this.setTree(false, this.treeData);
						this.checkTreeId(this.treeData);
					})
					.catch(() => {
						this.loadingTree = false;
					});
			} else {
				getRoleTreeData()
					.then((response) => {
						const data = response;
						data.unshift({
							id: 0,
							name: '角色树',
							parentId: null,
						});
						findAllSubSystemOne()
							.then((response) => {
								this.loadingTree = false;
								const subSystemList = response;
								subSystemList.forEach((subSystem) => {
									data.push({
										id: subSystem.id,
										name: subSystem.name,
										parentId: 0,
									});
								});
								this.treeData = TreeUtils.transformToTreeFormat(data);
								this.setTree(false, this.treeData);
								this.checkTreeId(this.treeData);
							})
							.catch(() => {
								this.loadingTree = false;
							});
					})
					.catch(() => {
						this.loadingTree = false;
					});
			}
		},
		// 加载用户组树
		loadGroupTreeData() {
			const params = {};
			const type = this.partyTypeIdValue !== '' ? this.partyTypeIdValue : '1';
			if (this.isUseScope) {
				// 选择器范围模式参数
				params.includeSub = type === '1';
				if (type === '3') {
					params.partyId = this.currentOrgIdValue;
				}
				if (type === 'script') {
					this.hiddenTree = false;
					this.getScriptData(this.scriptValue);
					this.loadingTree = false;
					return;
				}
			}
			const initTreeTypeMethods = TreeTypeEven.groupTypeEven.methods;
			const initTreeTypeEven = TreeTypeEven.groupTypeEven.methods.findTreeDataTypes;
			initTreeTypeEven(type, params, initTreeTypeMethods)
				.then((res) => {
					this.treeData = TreeUtils.transformToTreeFormat(res);
					this.setTree(false, this.treeData);
					this.checkTreeId(this.treeData);
					this.loadingTree = false;
				})
				.catch(() => {
					this.loadingTree = false;
				});
		},
	},
};
